module.exports = __webpack_public_path__ + "img/bg.fed18caa.jpg";